import axiosInstance from "auth/FetchInterceptor";
import { THIET_LAP_THUC_HANH_API } from "constants/ApiConstant";
const thietlapthuchanhService = {};

thietlapthuchanhService.create = function (data) {
  return axiosInstance.post(`${THIET_LAP_THUC_HANH_API}`, data);
};


thietlapthuchanhService.getbyid = function (id) {
  return axiosInstance.get(`${THIET_LAP_THUC_HANH_API}?id=${id}`);
};

export default thietlapthuchanhService;
